import xhttp from 'src/utils/xhttp'
import { formHeader } from 'src/utils/form-data'
import { WEBAPP_ENV_VARS_GROUP } from 'src/utils/constants'

/**
 * 添加应用
 * @param item
 * @returns {AxiosPromise<any>}
 */
export function add(item) {
    return xhttp.post('/api/dev/webapps', item, formHeader)
}

/**
 * 复制应用
 * @param item
 * @returns {AxiosPromise<any>}
 */
export function copy(item) {
    return xhttp.post('/api/dev/webapp/copy', item, formHeader)
}

/**
 * 删除应用
 * @param appId
 * @returns {AxiosPromise}
 */
export function del(appId) {
    return xhttp.delete(`/api/dev/webapp/${appId}`)
}

/**
 * 获取应用详情
 * @param appId
 * @returns {AxiosPromise<any>}
 */
export function detail(appId) {
    return xhttp.get(`/api/dev/webapp/${appId}`)
}

/**
 * 更新应用基本信息
 * @param data
 * @returns {AxiosPromise<any>}
 */
export function update(data) {
    return xhttp.put(`/api/dev/webapp/${data.id}`, data)
}

/**
 * 获取当前webapp 的版本信息
 * @param env
 * @param webappId
 * @param pageSize
 * @param page
 * @param status
 * @returns {AxiosPromise<any>}
 */
export function getAppVersions({
    env, webappId, pageSize, page = 1
}) {
    return xhttp.get(`/api/dev/webapp/${webappId}/version`, {
        params: { env, pageSize, page }
    })
}

/**
 * 添加一个 当前webapp 的版本信息
 * @param webappId
 * @param shellVersion
 * @param engineVersion
 * @param env
 * @param version
 * @param remark
 * @returns {Promise<AxiosResponse.data>}
 */
export function createAppVersion(webappId, shellVersion, engineVersion, env, version, remark) {
    return xhttp.post(`/api/dev/webapp/${webappId}/version`, {
        shellVersion,
        engineVersion,
        env,
        version,
        remark
    })
}

/**
 * 复制一个webapp 的版本信息
 * @param webappId
 * @param versionId
 * @param shellVersion
 * @param engineVersion
 * @param env
 * @param version
 * @param remark
 * @returns {AxiosPromise<any>}
 */
export function copyAppVersion(
    webappId,
    versionId,
    shellVersion,
    engineVersion,
    env,
    version,
    remark
) {
    return xhttp.post(`/api/dev/webapp/${webappId}/version/${versionId}/copy`, {
        shellVersion,
        engineVersion,
        env,
        version,
        remark
    })
}

/**
 * 删除一个 当前webapp 的版本信息
 * @param webappId
 * @param versionId
 * @returns {Promise<AxiosResponse.data>}
 */
export function deleteAppVersion(webappId, versionId) {
    return xhttp.delete(`/api/dev/webapp/${webappId}/version/${versionId}`)
}

/**
 * 检查当前版本是否可以删除
 * @param webappId
 * @param versionId
 */
export function checkVersionCanDelete(webappId, versionId) {
    return xhttp.get(`/api/dev/webapp/${webappId}/version/${versionId}/can-delete`)
}

/**
 * 发布当前webapp 的 版本
 * @param webappId
 * @param versionId
 * @returns {Promise<AxiosResponse.data>}
 */
export function publishAppVersion(webappId, versionId) {
    return xhttp.post(`/api/dev/webapp/${webappId}/version/${versionId}/publish`)
}

/**
 * 查询 webapp 各环境所有版本
 * @param webappId
 * @param isPublish 过滤是否启用过的
 * @returns Promise
 */
export function getAllAppVersions(webappId, isPublish = 0) {
    return xhttp.get(`/api/dev/webapp/${webappId}/all-versions`, {
        params: { isPublish }
    })
}

/**
 * 查询webapp各环境的最新所有版本
 * @param webappId
 * @returns Promise
 */
export function getLastAppVersions(webappId) {
    return xhttp.get(`/api/dev/webapp/${webappId}/latest-version`)
}

/**
 * 获取各个环境使用的最新的引擎版本
 * @param webappId
 * @returns {Promise<AxiosResponse.data>}
 */
export function getLastEngineVersions(webappId) {
    return xhttp.get(`/api/dev/webapp/${webappId}/latest-engine-version`)
}

/**
 * 获取 引擎列表
 * @returns {Promise<AxiosResponse.data>}
 */
export function getAllEngineVersions(params) {
    return xhttp.get('/api/dev/engine', { params })
}

/**
 * 构建应用
 * @param webappId
 * @param versionId
 * @param type
 * @returns {AxiosPromise<any>}
 */
export function buildAppVersion(webappId, versionId, type) {
    return xhttp.post(`/api/dev/webapp/${webappId}/version/${versionId}/build`, { type })
}

/**
 * 应用构建历史列表
 * @param page
 * @param status
 * @param webappId
 * @param versionId
 * @param pageSize
 * @returns {AxiosPromise<any>}
 */
export function getAppVersionBuilds(page, status, webappId, versionId, pageSize) {
    return xhttp.get(`/api/dev/webapp/${webappId}/version/${versionId}/build`, {
        params: {
            page,
            status,
            page_size: pageSize
        }
    })
}

/**
 * 应用构建状态
 * @param webappId
 * @param versionId
 * @returns {AxiosPromise<any>}
 */
export function getAppVersionBuildStatus(webappId, versionId) {
    return xhttp.get(`/api/dev/webapp/${webappId}/version/${versionId}/status`)
}

/**
 * 应用添加组件
 * @param webappId
 * @param versionId
 * @param components
 * @returns {AxiosPromise<any>}
 */
export function addAppVersionComponents(webappId, versionId, components, featureVersion) {
    return xhttp.post(`/api/dev/webapp/${webappId}/version/${versionId}/component`, { components, feature_version: featureVersion })
}

/**
 * 获取已引用组件列表
 * @param webappId
 * @param versionId
 * @returns {AxiosPromise<any>}
 */
export function getAppVersionUsedComponent(webappId, versionId) {
    return xhttp.get(`/api/dev/webapp/${webappId}/version/${versionId}/used-component`)
}

/**
 * 获取全部组件列表，带已使用标识，上版引用版本
 * @param webappId
 * @param versionId
 * @param oldVersionId
 * @param page
 * @param pageSize
 * @returns {AxiosPromise<any>}
 */
export function getAppVersionAllComponent(
    webappId,
    versionId,
    oldVersionId,
    page = 1,
    pageSize = 1000
) {
    return xhttp.get(`/api/dev/webapp/${webappId}/version/${versionId}/component`, {
        params: {
            page,
            oldVersionId,
            pageSize
        }
    })
}

/**
 * 获取基础组件列表
 */
export function getSystemComponent(versionId, previousVersionId) {
    return xhttp.get('/api/dev/system-component', {
        params: {
            versionId,
            previousVersionId
        }
    })
}

/**
 * 获取组件包，最新、最旧版本
 * @param webappId
 * @param oldVersionId
 * @returns {*}
 */
export function getAllComponentPackages(webappId, oldVersionId) {
    return xhttp.get(`/api/dev/webapp/${webappId}/component-packages`, {
        params: {
            oldVersionId
        }
    })
}

/**
 * 应用构建日志
 * @param webappId
 * @param groupId
 * @param preLogId
 * @param versionId
 * @param limit
 * @param type
 * @returns {AxiosPromise<any>}
 */
export function getBuildLogs(webappId, versionId, groupId, preLogId, type, limit) {
    return xhttp.get(`/api/dev/webapp/${webappId}/version/${versionId}/cmd-logs`, {
        params: {
            groupId, preLogId, type, limit
        }
    })
}

/**
 * 获取组件版本
 * @param componentId
 * @param webappId
 * @param page
 * @param pageSize
 * @returns {Promise<AxiosResponse.data>}
 */
export function getComponentVersions(componentId, webappId, page = 1, pageSize = 1000) {
    return xhttp.get(`/api/dev/component/${componentId}/version`, {
        params: { webappId, page, pageSize }
    })
}

/**
 * 获取当前应用API列表
 * @param webappId
 * @param env
 * @returns {AxiosPromise<any>}
 */
export function getAppApi(webappId, env) {
    return xhttp.get(`/api/dev/webapp/${webappId}/api`, { params: { env } })
}

/**
 * 保存应用API信息
 * @param webappId
 * @param env
 * @param apis
 * @returns {AxiosPromise<any>}
 */
export function saveAppApi(webappId, env, apis) {
    return xhttp.post(`/api/dev/webapp/${webappId}/api`, { env, apis })
}

/**
 * 获取应用壳版本信息
 * @param webappId
 * @param env
 * @returns {AxiosPromise<any>}
 */
export function getAppShellVersion(webappId, env) {
    return xhttp.get(`/api/dev/webapp/${webappId}/shell-version`, {
        params: { env }
    })
}

/**
 * 保存应用壳版本信息
 * @param webappId
 * @param env
 * @param iosAppstoreUrl
 * @param iosReleaseVer
 * @param androidApkUrl
 * @param androidReleaseVer
 * @returns {AxiosPromise<any>}
 */
export function saveAppShellVersion(
    webappId,
    env,
    iosAppstoreUrl,
    iosReleaseVer,
    androidApkUrl,
    androidReleaseVer
) {
    return xhttp.post(`/api/dev/webapp/${webappId}/shell-version`, {
        env,
        iosAppstoreUrl,
        iosReleaseVer,
        androidApkUrl,
        androidReleaseVer
    })
}

/**
 * 获取应用全部壳版本信息
 * @param webappId
 * @param env
 * @returns {AxiosPromise<any>}
 */
export function getAllAppShellVersion(webappId, env) {
    return xhttp.get(`/api/dev/webapp/${webappId}/all-shell-version`, {
        params: { env }
    })
}

/**
 * 获取应用静态资源域名
 * @param webappId
 * @param env
 * @returns {AxiosPromise<any>}
 */
export function getAppDomain({ webappId, env }) {
    return xhttp.get(`/api/dev/webapp/${webappId}/show-cdn-domain`, {
        params: { env }
    })
}

/**
 * 保存应用静态资源域名
 * @param webappId
 * @param domain
 * @param env
 * @returns {AxiosPromise<any>}
 */
export function setAppDomain(params) {
    return xhttp.post('/api/dev/webapp/save-cdn-domain', params)
}

/**
 * 获取租户列表
 * @param webappId
 * @param env
 * @param page
 * @param pageSize
 * @returns {AxiosPromise<any>}
 */
export function getTenantList(params) {
    return xhttp.get('/api/dev/tenant/tenant-list', { params })
}

/**
 * 升级租户版本
 * @param env
 * @param webappId
 * @param tenantIdArr
 * @param webappVersionId
 * @returns {AxiosPromise<any>}
 */
export function updateTenant(params) {
    return xhttp.post('/api/dev/tenant/update-tenant-version-multi', params)
}

/**
 * 删除租户
 * @param env
 * @param webappId
 * @param tenantIdArr
 * @param webappVersionId
 * @returns {AxiosPromise<any>}
 */
export function deleteTenant({ webappId, tenantId, env }) {
    return xhttp.delete(`/api/dev/webapp/${webappId}/tenant/${tenantId}?env=${env}`)
}

/**
 * 租户操作日志
 * @param env
 * @param webappId
 * * @returns {AxiosPromise<any>}
 */
export function TenantLog({ webappId, env }) {
    return xhttp.get(`/api/dev/tenant/operation-history?env=${env}&webapp_id=${webappId}&page=1`)
}

/**
 * 检查构建状态
 * @param  {} id
 */
export function checkBuildStatus(id) {
    return xhttp.get(`/api/dev/webapp/${id}/version?env=test&pageSize=10&page=1`)
}

/**
 * 获取阿里云日志列表
 * @param appId
 * @param env
 * @param params
 * @returns {*}
 */
export function getAliLogs({ appId, ...params }) {
    return xhttp.get(`/api/dev/alilog/${appId}`, { params })
}

/**
 * 获取阿里云日志
 * @param appId
 * @param id
 * @param cursor
 * @param type
 * @returns {*}
 */
export function getAliLog({
    appId, id, cursor, type = 'current'
}) {
    return xhttp.get(`/api/dev/alilog/${appId}/detail/${id}`, {
        params: { cursor, type }
    })
}

/**
 * 根据传入的应用名称，判断是否重复
 * @param webappName 应用名称
 * @returns {AxiosPromise<any>}
 */
export function checkAppNameRepeat(webappName) {
    return xhttp.get('/api/validate/webapp-name', { params: { webappName } })
}

// 新建模版
export function createNewTemplate(webappId, versionId, params) {
    return xhttp.post(`/api/dev/webapp/${webappId}/version/${versionId}/template`, params)
}

// 模版列表
export function getTemplateList(webappId, versionId, page = 1, pageSize = 13) {
    return xhttp.get(
        `/api/dev/webapp/${webappId}/version/${versionId}/getListTemplate?page=${page}&pageSize=${pageSize}`
    )
}

// 删除模版
export function deleteTemplate(webappId, versionId, templateId) {
    return xhttp.delete(`/api/dev/webapp/${webappId}/version/${versionId}/template/${templateId}`)
}

// 检测模版重名
export function checkTemplateName(webappId, versionId, name) {
    return xhttp.get(
        `/api/dev/webapp/${webappId}/version/${versionId}/CheckTemplateName?name=${name}`
    )
}

// 编辑模版
export function editTemplate(webappId, versionId, templateId, params) {
    return xhttp.post(
        `/api/dev/webapp/${webappId}/version/${versionId}/template/${templateId}/edit`,
        params
    )
}

// 下架模版
export function submitTemplate(webappId, versionId, templateId, params) {
    return xhttp.post(
        `/api/dev/webapp/${webappId}/version/${versionId}/template/${templateId}/status`,
        params
    )
}

// 复制模版
export function copyTemplate(webappId, versionId, templateId, params) {
    return xhttp.post(
        `/api/dev/webapp/${webappId}/version/${versionId}/template/${templateId}/copy`,
        params
    )
}

// 获取业务对象列表
export function getServiceList(webappId, page = 1, pageSize = 10) {
    return xhttp.get(`/api/dev/webapp/${webappId}/objects?page=${page}&pageSize=${pageSize}`)
}

// 新增业务对象
export function addService(webappId, params) {
    return xhttp.post(`/api/dev/webapp/${webappId}/objects`, params)
}

// 编辑业务对象
export function editService(webappId, objectId, params) {
    return xhttp.put(`/api/dev/webapp/${webappId}/objects/${objectId}`, params)
}

// 删除业务对象
export function deleteService(webappId, objectId) {
    return xhttp.delete(`/api/dev/webapp/${webappId}/objects/${objectId}`)
}

// 业务对象详情
export function getServiceDetail(webappId, objectId) {
    return xhttp.get(`/api/dev/webapp/${webappId}/objects/${objectId}`)
}

// 刷新详情接口
export function refreshServiceDetail(webappId, objectId) {
    return xhttp.put(`/api/dev/webapp/${webappId}/objects/${objectId}/refresh`)
}

// 新业务对象分组
export function getNewObjectGroup(webappId) {
    return xhttp.get(`/api/dev/webapp/${webappId}/data-component/object-groups`)
}
// 新增业务对象分组
export function addNewObjectGroup(webappId, params) {
    return xhttp.post(`/api/dev/webapp/${webappId}/data-component/object-groups`, params)
}
// 编辑业务对象分组
export function editNewObjectGroup(webappId, groupId, params) {
    return xhttp.put(`/api/dev/webapp/${webappId}/data-component/object-groups/${groupId}`, params)
}
// 删除业务对象分组
export function delNewObjectGroup(webappId, groupId) {
    return xhttp.delete(`/api/dev/webapp/${webappId}/data-component/object-groups/${groupId}`)
}

// 新业务对象列表
export function getNewObject(webappId, params) {
    return xhttp.get(`/api/dev/webapp/${webappId}/data-component/objects`, { params })
}
// 新增业务对象
export function addNewObject(webappId, params) {
    return xhttp.post(`/api/dev/webapp/${webappId}/data-component/objects`, params);
}
// 编辑业务对象
export function editNewObject(webappId, objectId, params) {
    return xhttp.put(`/api/dev/webapp/${webappId}/data-component/objects/${objectId}`, params)
}
// 删除业务对象
export function delNewObject(webappId, objectId) {
    return xhttp.delete(`/api/dev/webapp/${webappId}/data-component/objects/${objectId}`)
}
// 查询业务对象详情
export function getNewObjectDtl(webappId, objectId) {
    return xhttp.get(`/api/dev/webapp/${webappId}/data-component/objects/${objectId}`)
}

// 新业务对象字段列表
export function getNewObjectField(webappId, objectId) {
    return xhttp.get(`/api/dev/webapp/${webappId}/data-component/objects/${objectId}/fields`)
}
// 新增业务对象字段
export function addNewObjectField(webappId, objectId, params) {
    return xhttp.post(`/api/dev/webapp/${webappId}/data-component/objects/${objectId}/fields`, params);
}
// 编辑业务对象字段
export function editNewObjectField(webappId, objectId, fieldId, params) {
    return xhttp.put(`/api/dev/webapp/${webappId}/data-component/objects/${objectId}/fields/${fieldId}`, params)
}
// 删除业务对象字段
export function delNewObjectField(webappId, objectId, fieldId) {
    return xhttp.delete(`/api/dev/webapp/${webappId}/data-component/objects/${objectId}/fields/${fieldId}`)
}

// 新服务分组
export function getNewServiceGroup(webappId) {
    return xhttp.get(`/api/dev/webapp/${webappId}/data-component/service-groups`)
}
// 新增服务分组
export function addNewServiceGroup(webappId, params) {
    return xhttp.post(`/api/dev/webapp/${webappId}/data-component/service-groups`, params)
}
// 编辑服务分组
export function editNewServiceGroup(webappId, groupId, params) {
    return xhttp.put(`/api/dev/webapp/${webappId}/data-component/service-groups/${groupId}`, params)
}
// 删除服务分组
export function delNewServiceGroup(webappId, groupId) {
    return xhttp.delete(`/api/dev/webapp/${webappId}/data-component/service-groups/${groupId}`)
}

// 新服务列表
export function getNewService(webappId, params) {
    return xhttp.get(`/api/dev/webapp/${webappId}/data-component/services`, { params })
}
// 新增服务
export function addNewService(webappId, params) {
    return xhttp.post(`/api/dev/webapp/${webappId}/data-component/services`, params);
}
// 编辑服务
export function editNewService(webappId, serviceId, params) {
    return xhttp.put(`/api/dev/webapp/${webappId}/data-component/services/${serviceId}`, params)
}
// 删除服务
export function delNewService(webappId, serviceId) {
    return xhttp.delete(`/api/dev/webapp/${webappId}/data-component/services/${serviceId}`)
}

export function getWebappVars(webappId, env) {
    return xhttp.get(
        `/api/dev/webapp/${webappId}/env/${env}/group/${WEBAPP_ENV_VARS_GROUP}/env-vars`
    )
}

export function setWebappVars(webappId, env, vars) {
    return xhttp.post(
        `/api/dev/webapp/${webappId}/env/${env}/group/${WEBAPP_ENV_VARS_GROUP}/env-vars`,
        { env_vars: vars }
    )
}

// app 升级
export function getAppUpgradeConfig(params) {
    return xhttp.get('/api/dev/app-upgrade', { params })
}
export function putAppUpgradeConfig(params) {
    return xhttp.post('/api/dev/app-upgrade', params)
}

/**
 * 获取租户列表
 * @param webappId
 * @package tenantCode
 * @param env
 * @returns {AxiosPromise<any>}
 */
export function getTenantUpdateInfo(params) {
    return xhttp.get('/api/dev/tenant/tenant-update-info', { params })
}

/**
 * 获取app版本引用组件-我的组件列表
 * @param webappId
 * @param versionId
 * @param oldVersionId
 * @param name
 * @param groupId
 * @returns {AxiosPromise<any>}
 */
export function getAppVersionMyComponentList(
    webappId,
    versionId,
    oldVersionId,
) {
    return xhttp.get(`/api/dev/webapp/${webappId}/version/${versionId}/my-component`, {
        params: {
            oldVersionId
        }
    })
}

/**
 * 获取app版本引用组件-系统组件列表
 */
export function getSystemComponentList(versionId, previousVersionId) {
    return xhttp.get('/api/dev/system-component', {
        params: {
            versionId,
            previousVersionId,
        }
    })
}
/**
 * 添加子应用
 * @param webappId
 * @param params
 * @returns {AxiosPromise<any>}
 */
export function addChildApp(params) {
    return xhttp.post(`/api/dev/webapp/${params.webappId}/createChildren`, params)
}

/**
 * 获取子应用
 * @param webappId
 * @returns {AxiosPromise<any>}
 */
export function childAppList(webappId) {
    return xhttp.get(`/api/dev/webapp/${webappId}/children`, {
        params: {
            webapp_id: webappId
        }
    })
}

export function getParentVersions(webappId) {
    return xhttp.get(`/api/dev/webapp/${webappId}/parent-versions`, {
        params: {
            webappId
        }
    })
}

/**
 * 从父应用复制
 * @param webappId
 * @param versionId
 * @param shellVersion
 * @param engineVersion
 * @param env
 * @param version
 * @param remark
 * @returns {AxiosPromise<any>}
 */
export function copyParentApp({
    webappId, versionId, shellVersion, engineVersion, env, version, remark
}) {
    return xhttp.post(`/api/dev/webapp/${webappId}/version/${versionId}/copy-parent`, {
        shellVersion,
        engineVersion,
        env,
        version,
        remark
    })
}

/**
 * * 获取业务对象详情
 * @param webappId
 * @param id
 */
export function getObjectDetail({
    webappId, id
}) {
    return xhttp.get(`/api/dev/webapp/${webappId}/data-component/objects/${id}`, {
        webappId, id
    })
}
